import { BANNER_LIST, BANNER_LIST_SUCCESS, BANNER_LIST_FAILED } from "./bannerActionTypes";

/*
 * item example:
 * {
 *   id: 1,
 *   product: {...}
 *   options: [
 *     {optionId: 1, optionTitle: 'Color', valueId: 1, valueTitle: 'Red'}
 *   ],
 *   price: 250,
 *   quantity: 2,
 *   total: 500
 * }
 * extraLine example:
 * {
 *   type: 'shipping',
 *   title: 'Shipping',
 *   price: 25
 * }
 */
const initialState = {
    loading: 0,
    items: [],
};

export default function bannerReducer(state = initialState, action) {
    switch (action.type) {
        case BANNER_LIST:
            return { ...state, action };
        case BANNER_LIST_SUCCESS:
            return { ...state, ...{ items: action.items } };
        case BANNER_LIST_FAILED:
            return { ...state, ...{ items: action.items } };

        default:
            return state;
    }
}
